<template>
  <div class="banner-pan posRe">
    <template v-if="state==2">
      <div class="city-pan-logo" v-if="logo">
        <img class="animated bounceIn" :src="logo"/>
      </div>
    </template>
    <template v-else>
      <img v-if="logo" class="logo animated bounceIn" :src="logo"/>
    </template>
    <template v-if="panUrl">
      <a v-if="seePanUrl" :href="seePanUrl" class="icon-img icon-see-pan"></a>
      <div class="iframe iframe-pan" id="iframe-pan">
        <iframe id="frameA" ref="iframeA" class="" :src="panUrl" name="frameA"></iframe>
        <!--<iframe id="frameA" ref="iframeA" class="" src="http://pano.szscmap.com/city/sichuan/" name="frameA"></iframe>-->
      </div>
    </template>
    <template v-else>
      <div class="no-data"  :class="[panUrl||logo?logo?'has-logo':'':'no-iframe-pan']"></div>
    </template>
    <div class="swiper-container container-pan">
      <div class="swiper-wrapper">
        <template v-if="paoThumbData&&paoThumbData.length">
          <template v-for="(list,index) in paoThumbData">
            <div class="swiper-slide" :class="[(paoThumbIndex==index?'active':'')]" :key="'pan'+index">
              <div class="pan-name" :class="[list.pano_id?'':'no-list-data']" @click="panClick(index,list.pano_id)">
                <div class="pan-text"><span>{{list.title||'重点推荐'}}</span></div>
                <div class="pan-icon"></div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <template v-if="state!==2">
      <div class="pan-address animated fadeInUp">
        <div class="swiper-container container-address">
          <div class="swiper-wrapper">
            <template v-if="addressList&&addressList.length">
              <template v-for="(item, i) in addressList">
                <div class="swiper-slide" :class="['slide-address'+i,item.state?'':'no-click']" :key="'addressList'+i">
                  <div @click="pageCityTo(item)">{{item.name}}</div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </template>
    <popup :show-bool="popupBool" @toggle="showVal"></popup>
  </div>
</template>
<script>
  import popup from '@/components/popup'
export default {
  props: ['state'],
  name: 'phonePan',
  data () {
    return {
      logo: '',
      lists: [],
      addressList: [],
      panUrl: '',
      activeIndex: 0,
      loaded: false,
      paoThumbData: [],
      paoThumbIndex: 0,
      iframeWin: {},
      seePanUrl: '',
      swiperPanObj: '',
      cityId: 0,
      cityIndex: -1,
      countyIndex: -1,
      panActiveIndex:0,
      timer:null,
      popupBool:false
    }
  },
  components:{
    popup:popup
  },
  created () {
    let that = this;
    let currentParams = JSON.parse(this.publicJs.decode(that.$route.query));
    that.cityId = currentParams.cityId || 0;
    that.cityIndex = currentParams.cityIndex;
    that.countyIndex = currentParams.countyIndex
  },
  mounted () {
    let that = this;
    that.httpData()
  },
  methods: {
    showVal:function (val) {
      this.popupBool=val;
    },
    panClick: function (index,pano_id) {

      let that=this;
      if(pano_id){
        clearInterval(that.timer);
        that.swiperPanObj.slideTo(index);
        that.iframeWin.postMessage({
          cmd: 'activeIndex',
          activeIndex: index
        }, '*');
        that.panActiveIndex=index;
      }

    },
    httpData: function () {
      let _that = this;
      let i=_that.$root.panIndex;
      _that.panActiveIndex=i;
      _that.httpAjax.getAjax('CityWebService.asmX/GetSiteInfoByCity', {cityId: _that.cityId}).then(function (res) {
        if (res.code === 1) {
          _that.lists = res.data;
          _that.logo = _that.lists[_that.activeIndex].logo;
          _that.panUrl = _that.lists[_that.activeIndex].panoUrl;
          _that.$nextTick(function () {
            if (_that.$refs.iframeA) {
              window.addEventListener('message', function (event) {
                let data = JSON.parse(JSON.stringify(event.data));
                if (data.msg === 'success') {
                  if(data.isList){
                    let len=data.data && data.data.length?data.data.length:0;
                    if(len){
                      _that.paoThumbData=data.data;
                      _that.swiperPan(i)
                    }
                  }

                  if (data.activeIndex >= 0) {
                    _that.paoThumbIndex = data.activeIndex;
                    _that.seePanUrl = _that.paoThumbData[data.activeIndex].url
                  }
                }
              });
              _that.iframeWin = _that.$refs.iframeA.contentWindow
            }
          })
          _that.publicJs.panMousewheel()
        }
      }, function (err) {
        console.log(err)
      })
      this.publicJs.addressGetData(function (res) {
        if (res.code === 1) {
          let currentData = JSON.parse(JSON.stringify(res.data));
          _that.addressList = currentData;
          if (_that.state === 2) {
            let b=_that.publicJs.onlyCityData(currentData,_that.cityId)||{'name': _that.$realmNameId==50?'重庆':'四川', cityId: '0'};
            console.log(b)
            _that.$emit('addressCurrent', b)
          }
        }
      })
    },
    pageCityTo: function (city) {
      if(!city.state){
        this.popupBool=true;
        return false;
      }
      this.$router.push({
        path: '/phoneCity',
        query: {
          key: this.publicJs.encode(JSON.stringify({
            cityId: city.cityId,
          })),
          '_': new Date().getTime()
        }
      })
    },
    swiperPan: function (n) {
      let _that = this
      setTimeout(function () {
        // eslint-disable-next-line
        _that.swiperPanObj = new Swiper('.container-pan', {
          slidesPerView: 'auto',
          spaceBetween: 10,
          watchOverflow: true,
          on:{
            init:function(){if(n>0){
              _that.iframeWin.postMessage({
                cmd: 'activeIndex',
                activeIndex: n
              }, '*');
              _that.timeSwiper(n);
            }else {
              _that.timeSwiper(this.activeIndex)
            }
            },
            slideChangeTransitionStart:function(){
              console.log('slideChangeTransitionStart')
            },
          }
        })
      }, 50)
    },
    timeSwiper:function (n) {
      let _that=this,
        list=_that.paoThumbData,
        len=list&&list.length?list.length:0;

      if(len<=1){
        return false;
      }

      _that.timer=setInterval(function () {
        let i=((n==(len-1))?0:n+1);
        if(list[i].pano_id){
          _that.swiperPanObj.slideTo(i);
          _that.iframeWin.postMessage({
            cmd: 'activeIndex',
            activeIndex: i
          }, '*');
        }
        _that.panActiveIndex=i;
        clearInterval(_that.timer);

      },15000)
    },
    swiperAddress: function () {
      setTimeout(function () {
        // eslint-disable-next-line
        let containerAddress = new Swiper('.container-address', {
          slidesPerView: 'auto',
          spaceBetween: 10,
          watchOverflow: true,
          centerInsufficientSlides: true,
          breakpoints: {
            1380: {
              // spaceBetween: 110
            }
          },
          on: {
            init: function () {
            }
          }
        })
      }, 50)
    }
  },
  beforeDestroy(){
    this.$root.panIndex=this.panActiveIndex;
    if(this.timer){
      clearInterval(this.timer)
    }
  },
  watch: {
    lists: function (a, b) {
      // this.swiperPan()
    },
    addressList: function (a, b) {
      this.swiperAddress()
    },
    panActiveIndex:function (newVal,b) {
      if(newVal!=b){
        this.timeSwiper(newVal)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner-pan{
    height: 404px;
    background-color:#e7f6ff;
    overflow: hidden;
  }
  .logo{
    position: absolute;
    width:80%;
    left: 10%;
    height: 162.5px;
    z-index: 2;
    top:100.5px;
    object-fit: scale-down;
  }
  .phone-city .city-pan-logo{
    position: absolute;
    left:50%;
    width: 80%;
    max-width: 590px;
    height: 145px;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
    /*border:1px solid red;*/
    z-index: 2;
    top:140px;
  }
  .phone-city .city-pan-logo img{
    height: 100%;
    object-fit: scale-down;
  }
  .container-pan{
    position: absolute;
    left: 10px;
    right: 0;
    top:55px;
  }
  .container-pan .swiper-slide{
    width: auto;
  }
  .container-pan .no-list-data{
    opacity: 0.5;
  }
  .pan-text span{
    display: inline-block;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
    padding-bottom: 2px;
    text-align: center;
    letter-spacing: 1px;
    font-family: PingFang-SC,SimSun,'Segoe UI',Arial,'Microsoft Yahei',sans-serif;
    text-shadow: 0 1px 2px black;
  }
  .active .pan-text span{
    border-bottom:1px solid white;
  }

  .pan-address{
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 7.5px;
    z-index: 2;
  }
  .pan-address .swiper-container{
    margin: 0 auto;
  }
  .pan-address .swiper-slide{
    width: auto;
    padding: 1px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .pan-address .swiper-slide>div{
    font-size: 15px;
    color: #F2F2F2;
    border: 1px solid #FFFFFF;
    border-radius: 5px;
    padding: 5px 12.5px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    letter-spacing: 2px;
  }
  .pan-address .swiper-slide:hover{
    color: #f6bc32;
    font-weight: bold;
    -webkit-transition: color 0.5s ease-in-out;
    -moz-transition: color 0.5s ease-in-out;
    -ms-transition: color 0.5s ease-in-out;
    -o-transition: color 0.5s ease-in-out;
    transition: color 0.5s ease-in-out;
  }
  .pan-address .swiper-slide.no-click>div{
    border-color: #c5c5c5;
    color: #c5c5c5;
  }
  .no-data{
    height: 80%;
    margin-top: 10%;
  }
  .no-data.no-iframe-pan{
    background-size: cover;
  }
  .no-data.has-logo{
    background-image: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Phone/pan.vue